@import '../../../constants/spacing.module.less';

.recommendation-loading-indicator-container {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  gap: @space-4;
  flex: 1;
}

.recommendation-loading-indicator {
  display: flex;
  flex-flow: column nowrap;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
}

.recommendation-loading-indicator-icon {
  width: 24px;
  height: 24px;
}

.recommendation-applied-banner-content {
  display: flex;
  flex: 1;
  flex-flow: row nowrap;
  gap: @space-4;
  justify-content: space-between;
  align-items: flex-start;
}

.recommendation-applied-text {
  flex: 1;
}

.recommendation-applied-checkmark {
  width: 24px;
  height: 24px;
  padding: @space-4;
}

.recommendation-applied-checkmark-light {
  color: var(--pine-green);
}

.recommendation-applied-checkmark-medium,
.recommendation-applied-checkmark-dark {
  color: var(--grey-300);
}

.recommendation-banner-content {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  gap: @space-8;
}

.recommendation-text-wrapper {
  flex: 1;
}
